import { render, staticRenderFns } from "./AcademyInternal.vue?vue&type=template&id=a95161a0&scoped=true&"
import script from "./AcademyInternal.vue?vue&type=script&lang=js&"
export * from "./AcademyInternal.vue?vue&type=script&lang=js&"
import style0 from "./AcademyInternal.vue?vue&type=style&index=0&id=a95161a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95161a0",
  null
  
)

export default component.exports